import { z } from 'zod';
export const contactCreateSchema = z.object({
    name: z.string().min(1).max(120).trim(),
    email: z.string().email().toLowerCase().trim(),
    subject: z.string().min(1).max(200).trim(),
    message: z.string().min(1).max(5000).trim(),
});
export const contactMessageSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string().email(),
    subject: z.string(),
    message: z.string(),
    isRead: z.boolean(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=contact.js.map